// extracted by mini-css-extract-plugin
module.exports = {"picture":"picture_picture__1A6-Y","logo":"picture_logo__2F-th","user":"picture_user__andkn"};